<template>

  <div>
    <div v-if="game" >
      <div class="container" >
        <div class='row'>
          <div class="col"><h4>{{game.name}}</h4></div>
        </div>
        <div class='row'>
          <div class="col"><span v-if="game.completed">Winner</span><span v-else>Leader</span>: {{winner}}</div>
        </div>
        <playerheader :players="game.roster.players" :completionType="game.completiontype" :gameId="game.id"/>
        <div class="h-divider"/>
        <rounds :game="game" :rounds="game.rounds" :players="game.roster.players" :gameOver="game.completed"/>
        <pointtotals :players="game.roster.players" :scores="game.currentScores" :gameOver="game.completed"/>
        <div class="h-divider"/>
      </div>
    </div>
  </div>
</template>
 
<script>
import { mapGetters } from 'vuex'
import playerheader from "./PlayerHeader"
import rounds from './Rounds.vue'
import pointtotals from './PointTotals.vue';

export default {
  name: "scoresheet",
  components: {
    playerheader,
    rounds,
    pointtotals
  },
  computed: {
    ...mapGetters('game', {
      game: 'currentGame'
    }),
    winner() {
      return this.game.winner? this.game.winner.name: ""
    }
    // game() {
      // return this.$store.getters.getGame(this.$route.params.id)
    // }
  },
  mounted() {
    /* eslint-disable no-console */
    console.log('Scoresheet component mounted.')
    this.$store.dispatch('game/retrieveGame', this.$route.params.id);
    /* eslint-enable no-console */
  }
};
</script>

<style scoped type="text/css">

.h-divider{
 margin-top:1px;
 margin-bottom:1px;
 height:1px;
 width:100%;
 border-top:1px solid gray;
}

.container {
  display: flex; /* or inline-flex */
  flex-direction: column;
  background-color: white;
}

.row {
  display: flex; /* or inline-flex */
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: space-around;
  align-content: center;
  justify-content: space-between;
}
.row > * {
  flex: 1 100%;
}

.col {
  padding: 5px;
  
  line-height: 15px;
  font-weight: bold;
  font-size: 1em;
  text-align: center;
}
</style>